export default "__VITE_ASSET__CU_Zi97$__"